// Full Immunotec product catalog with details extracted from the official document.
// Each product has an AI-generated emotional image and (where available) an official product image.
export const products = [
  {
    slug: "immunocal-azul",
    image: "/products/official/immunocal-azul.jpg",
    officialImage: "/products/official/immunocal-azul.jpg",
    sachetImage: "/products/lifestyle/immunocal-azul.png",
    name: { es: "Immunocal", en: "Immunocal Original" },
    tagline: {
      es: "Precursor de glutatión para fortaleza inmune.",
      en: "Glutathione precursor for immune strength.",
    },
    description: {
      es: "Immunocal® es un suplemento precursor de glutatión (el antioxidante maestro) que ayuda a fortalecer tu sistema inmunológico.",
      en: "Immunocal® is a glutathione precursor supplement that helps strengthen your immune system.",
    },
    benefits: {
      es: [
        "Fortalece el sistema inmunológico",
        "Desintoxica metales pesados y toxinas",
        "Protege células del estrés oxidativo",
        "Construye y repara tejidos",
        "Incrementa la energía celular",
      ],
      en: [
        "Strengthens immune system",
        "Detoxifies heavy metals & toxins",
        "Protects cells from oxidative stress",
        "Builds and repairs tissue",
        "Increases cellular energy",
      ],
    },
    ingredients: ["Aislado de proteína de suero de leche (cisteína)", "Polidextrosa (fibra)"],
    usage:
      "1 a 2 sobres al día en ayunas, diluidos en 100 ml de agua o jugo (no calentar). Agitar 30 segundos.",
    targets: ["Sistema inmunológico débil", "Toxinas", "Estrés oxidativo", "Radicales libres"],
    presentation: "Caja con 30 sobres de 12.9 g",
  },
  {
    slug: "immunocal-platinum",
    image: "/products/official/immunocal-platinum.jpg",
    officialImage: "/products/official/immunocal-platinum.jpg",
    sachetImage: "/products/official/immunocal-platinum-sobre.png",
    name: { es: "Immunocal Platinum", en: "Immunocal Platinum" },
    tagline: {
      es: "Fórmula de alta gama anti-inflamatoria y balance pH.",
      en: "High-end formula for inflammation and pH balance.",
    },
    description: {
      es: "Immunocal Platinum® refuerza el sistema inmunológico y suma 3 componentes adicionales: CMP™ para inflamación, RMF™ para equilibrio pH y Creatina para músculo y huesos.",
      en: "Immunocal Platinum® reinforces the immune system and adds CMP™, RMF™ and Creatine for inflammation, pH balance and muscle/bone support.",
    },
    benefits: {
      es: [
        "Refuerza el sistema inmunológico",
        "Regula la inflamación (CMP™)",
        "Equilibrio natural del pH (RMF™)",
        "Mejora el rendimiento físico (Creatina)",
        "Mantiene masa muscular y huesos",
      ],
      en: [
        "Strengthens immune system",
        "Modulates inflammation (CMP™)",
        "Natural pH balance (RMF™)",
        "Boosts physical performance (Creatine)",
        "Preserves muscle and bones",
      ],
    },
    ingredients: [
      "Aislado de Proteína de Suero (cisteína)",
      "CMP™ Péptidos Moduladores de Citoquinas",
      "RMF™ Redox Modulating Formula",
      "Creatina monohidrato",
      "Citratos de potasio, sodio, calcio, magnesio",
    ],
    usage:
      "Mantenimiento 1 sobre/día · Terapéutica 2 sobres (mañana y tarde) · Correctiva 3 sobres (mañana, tarde, noche).",
    targets: ["Inflamación", "Acidez corporal", "Bajo rendimiento físico", "Pérdida de masa muscular"],
    presentation: "Caja con 30 sobres de 12.5 g",
  },
  {
    slug: "immunocal-sport",
    image: "/products/official/immunocal-sport.jpg",
    officialImage: "/products/official/immunocal-sport.jpg",
    sachetImage: "/products/lifestyle/immunocal-sport.png",
    name: { es: "Immunocal Sport", en: "Immunocal Sport" },
    tagline: {
      es: "Suero bioactivo con Nitro Boost para atletas.",
      en: "Bioactive whey with Nitro Boost for athletes.",
    },
    description: {
      es: "Immunocal Sport® combina la tecnología de refuerzo inmune con nutrición deportiva avanzada para aumentar masa muscular, fuerza y resistencia.",
      en: "Immunocal Sport® combines immune support with advanced sports nutrition to grow muscle, strength and stamina.",
    },
    benefits: {
      es: [
        "Refuerza el sistema inmune",
        "Aumenta masa muscular, fuerza y resistencia",
        "Recuperación más rápida",
        "Optimiza oxigenación e hidratación",
        "Disminuye el ácido láctico",
      ],
      en: [
        "Boosts immune system",
        "Builds muscle, strength and stamina",
        "Faster recovery",
        "Better oxygenation & hydration",
        "Reduces lactic acid",
      ],
    },
    ingredients: [
      "Aislado de proteína de suero con cisteína",
      "Nitro Boost",
      "L-Citrulina",
      "Raíz de remolacha",
      "Citrato de magnesio",
      "Vitamina C, B12, Selenio",
    ],
    usage:
      "1 sobre al día. Se puede combinar con Immunocal o Immunocal Platinum antes de mezclar con 250 ml de agua o jugo.",
    targets: ["Bajo rendimiento deportivo", "Recuperación lenta", "Ácido láctico", "Inmunidad de atleta"],
    presentation: "Caja con 30 sobres de 12.5 g",
  },
  {
    slug: "knutric-rodiola",
    image: "/products/official/knutric-rodiola.jpg",
    officialImage: "/products/official/knutric-rodiola.jpg",
    sachetImage: "/products/lifestyle/knutric-rodiola.png",
    name: { es: "Knutric+ con Rodiola", en: "Knutric+ with Rhodiola" },
    tagline: {
      es: "Fitonutrientes adaptógenos contra estrés y fatiga.",
      en: "Adaptogenic phytonutrients for stress and fatigue.",
    },
    description: {
      es: "Knutric+® es una mezcla exclusiva de fitonutrientes con Rhodiola, un poderoso adaptógeno que ayuda a tu cuerpo a equilibrar el estrés.",
      en: "Knutric+® is a unique blend of phytonutrients with Rhodiola, a powerful adaptogen that helps your body balance stress.",
    },
    benefits: {
      es: [
        "Fortalece el sistema inmunológico",
        "Mejora el metabolismo",
        "Protección natural contra el estrés",
        "Disminuye la fatiga mental",
        "Aumenta energía y rendimiento",
      ],
      en: [
        "Strengthens immune system",
        "Improves metabolism",
        "Natural stress protection",
        "Reduces mental fatigue",
        "Boosts energy and performance",
      ],
    },
    ingredients: ["Rhodiola", "Potasio", "Yodo", "Magnesio", "Boro"],
    usage:
      "1 cucharada (15 ml) una vez al día, en 125 ml de agua o tu bebida favorita. Evítalo antes de dormir.",
    targets: ["Estrés físico, químico y mental", "Fatiga mental", "Bajo rendimiento físico"],
    presentation: "Botella de 473.2 ml",
  },
  {
    slug: "multi-resveratrol",
    image: "/products/official/multi-resveratrol.jpg",
    officialImage: "/products/official/multi-resveratrol.jpg",
    sachetImage: "/products/lifestyle/multi-resveratrol.png",
    name: { es: "Multi + Resveratrol", en: "Multi + Resveratrol" },
    tagline: {
      es: "Multivitamínico integral con 3 nutrientes clave.",
      en: "Complete multivitamin with 3 hero nutrients.",
    },
    description: {
      es: "Multi+ Resveratrol es el multivitamínico ideal para preservar tu cuerpo en un estado wellness integral, con 13 vitaminas, 5 minerales y 3 nutrientes.",
      en: "Multi+ Resveratrol is the ideal multivitamin to keep your body in full wellness, with 13 vitamins, 5 minerals and 3 hero nutrients.",
    },
    benefits: {
      es: [
        "Apoya el sistema inmune",
        "Metaboliza grasas, proteínas e hidratos",
        "Buen metabolismo de la glucosa",
        "Salud de huesos, dientes y encías",
        "Antioxidante, antiinflamatorio y antienvejecimiento",
      ],
      en: [
        "Supports immune system",
        "Helps metabolize fats, proteins and carbs",
        "Healthy glucose metabolism",
        "Bone, teeth and gum health",
        "Antioxidant, anti-inflammatory, anti-aging",
      ],
    },
    ingredients: ["13 vitaminas", "5 minerales", "3 nutrientes", "Algas Chlorella", "Resveratrol"],
    usage: "2 cápsulas al día con cualquiera de los 3 alimentos.",
    targets: ["Deficiencias dietéticas", "Baja energía", "Envejecimiento celular"],
    presentation: "Frasco con 60 cápsulas de 575 mg",
  },
  {
    slug: "probiotico-3-1",
    image: "/products/official/probiotico-3-1.jpg",
    officialImage: "/products/official/probiotico-3-1.jpg",
    sachetImage: "/products/lifestyle/probiotico-3-1.png",
    name: { es: "Probiótico 3+1", en: "Probiotic 3+1" },
    tagline: {
      es: "Sinbiótico con 7 cepas + prebióticos + antioxidantes.",
      en: "Synbiotic with 7 strains + prebiotics + antioxidants.",
    },
    description: {
      es: "Probiótico 3+ es un simbiótico con 7 cepas probióticas, prebióticos y antioxidantes que promueven una digestión saludable y favorecen el eje intestino-cerebro.",
      en: "Probiotic 3+ is a synbiotic with 7 probiotic strains, prebiotics and antioxidants that promote healthy digestion and gut–brain axis.",
    },
    benefits: {
      es: [
        "Ayuda al sistema inmune",
        "Limpieza natural del aparato digestivo",
        "Mejor absorción de vitaminas y minerales",
        "Controla la intolerancia a la lactosa",
        "Salud bucal y prevención de infecciones urinarias",
        "Estado de ánimo positivo (cerebro-intestino)",
      ],
      en: [
        "Supports immune system",
        "Natural digestive cleansing",
        "Better vitamin & mineral absorption",
        "Controls lactose intolerance",
        "Oral health and UTI prevention",
        "Positive mood via gut–brain axis",
      ],
    },
    ingredients: [
      "7 cepas probióticas (Bifidobacterium, Lactobacillus)",
      "Fibra prebiótica",
      "Arándano rojo",
      "Antioxidantes",
    ],
    usage:
      "1 cápsula al día con alimentos. Para metabolismo: 2 cápsulas en ayunas durante 1 mes. Gastroenteritis: 1 cápsula cada 8 h × 3 días.",
    targets: [
      "Problemas digestivos",
      "Intolerancia a lactosa",
      "Estrés y depresión",
      "Fatiga",
      "Infecciones urinarias",
    ],
    presentation: "Frasco con 30 cápsulas de 596 mg",
  },
  {
    slug: "klc-d",
    image: "/products/official/klc-d.jpg",
    officialImage: "/products/official/klc-d.jpg",
    sachetImage: "/products/lifestyle/klc-d.png",
    name: { es: "KLC-D", en: "KLC-D" },
    tagline: {
      es: "Complejo mineral lácteo + Vitamina D para huesos fuertes.",
      en: "Milk mineral complex + Vitamin D for strong bones.",
    },
    description: {
      es: "KLC-D es más que calcio: un complejo mineral de leche con 400 UI de vitamina D por ración que maximiza la absorción.",
      en: "KLC-D is more than calcium: a milk mineral complex with 400 IU of Vitamin D per serving for maximum absorption.",
    },
    benefits: {
      es: [
        "Mantiene dientes y huesos sanos",
        "Previene la osteoporosis",
        "Ayuda a la función nerviosa y muscular",
        "Apoya el metabolismo",
      ],
      en: [
        "Healthy teeth and bones",
        "Prevents osteoporosis",
        "Supports nerve & muscle function",
        "Supports metabolism",
      ],
    },
    ingredients: [
      "Calcio",
      "Vitamina D",
      "Fósforo",
      "Magnesio, Potasio, Cobre, Hierro, Zinc",
      "Proteína de suero",
    ],
    usage: "2 tabletas al día. No administrar en menores de 12 años.",
    targets: ["Dientes débiles", "Osteoporosis", "Problemas nerviosos o musculares"],
    presentation: "Frasco con 60 tabletas de 1,288 mg",
  },
  {
    slug: "zenity",
    image: "/products/official/zenity.jpg",
    officialImage: "/products/official/zenity.jpg",
    sachetImage: "/products/lifestyle/zenity.png",
    name: { es: "Zenity", en: "Zenity" },
    tagline: {
      es: "Magnesio + Péptido bioactivo para calma y sueño reparador.",
      en: "Magnesium + Bioactive peptide for calm and restorative sleep.",
    },
    description: {
      es: "Zenity® (antes PNT 200) combina Magnesio con un péptido bioactivo (Alfa-Casozepina) para reducir el estrés y mejorar la calidad del sueño, sin generar dependencia.",
      en: "Zenity® (formerly PNT 200) combines Magnesium with a bioactive peptide (Alpha-Casozepine) to reduce stress and improve sleep quality, non-addictive.",
    },
    benefits: {
      es: [
        "Reduce estrés mental y físico",
        "Promueve un sueño reparador",
        "Apoya la función muscular y nerviosa",
        "Relajación natural sin adicción",
      ],
      en: [
        "Reduces mental and physical stress",
        "Promotes restful sleep",
        "Supports muscle and nerve function",
        "Natural relaxation, non-addictive",
      ],
    },
    ingredients: ["Magnesio", "Péptido bioactivo Alfa-Casozepina"],
    usage: "1 a 3 cápsulas al día, preferentemente antes de dormir.",
    targets: ["Estrés", "Insomnio", "Ansiedad", "Tensión muscular"],
    presentation: "Frasco con 30 cápsulas de 550 mg",
  },
  {
    slug: "omega-gen-v",
    image: "/products/official/omega-gen-v.jpg",
    officialImage: "/products/official/omega-gen-v.jpg",
    sachetImage: "/products/lifestyle/omega-gen-v.png",
    name: { es: "Omega Gen V (5 en 1)", en: "Omega Gen V (5-in-1)" },
    tagline: {
      es: "Omega-3 + CoQ10 + Cúrcuma + Vitamina E + Piperina.",
      en: "Omega-3 + CoQ10 + Turmeric + Vitamin E + Piperine.",
    },
    description: {
      es: "Omega Gen V® combina 5 componentes de élite para salud cognitiva, estado de ánimo, función cerebral, salud visual e inmunidad.",
      en: "Omega Gen V® combines 5 elite components for cognitive health, mood, brain function, eye health and immunity.",
    },
    benefits: {
      es: [
        "Salud cognitiva y mejor estado de ánimo",
        "Mejora funciones cerebrales y memoria",
        "Mantiene salud visual",
        "Soporte cardiovascular",
        "Combate radicales libres",
      ],
      en: [
        "Cognitive health & mood",
        "Better brain function & memory",
        "Eye health",
        "Cardiovascular support",
        "Fights free radicals",
      ],
    },
    ingredients: ["Omega-3 EPA y DHA", "CoQ10", "Cúrcuma", "Vitamina E", "Piperina (pimienta negra)"],
    usage: "4 cápsulas al día con cualquier comida, preferentemente desayuno.",
    targets: ["Problemas cognitivos", "Bajo ánimo", "Memoria", "Disfunción cardíaca o cerebral"],
    presentation: "Frasco con 120 cápsulas de 500 mg",
  },
  {
    slug: "optimizer",
    image: "/products/official/optimizer.jpg",
    officialImage: "/products/official/optimizer.jpg",
    sachetImage: "/products/lifestyle/optimizer.png",
    name: { es: "Optimizer Rojos y Verdes", en: "Optimizer Reds & Greens" },
    tagline: {
      es: "50+ polifenoles que activan los genes Nrf2.",
      en: "50+ polyphenols that activate Nrf2 genes.",
    },
    description: {
      es: "Immunocal Optimizer® Rojos y Verdes activa tus genes de supervivencia Nrf2 y suma 50+ polifenoles y fitonutrientes orgánicos para potenciar tu glutatión.",
      en: "Immunocal Optimizer® Reds & Greens activates Nrf2 survival genes and adds 50+ organic polyphenols and phytonutrients to potentiate glutathione.",
    },
    benefits: {
      es: [
        "Activa genes de supervivencia Nrf2",
        "Recarga el Glutatión",
        "Potencializa los antioxidantes",
        "Fortalece el sistema inmunológico",
        "Detoxifica el cuerpo",
      ],
      en: [
        "Activates Nrf2 survival genes",
        "Recharges Glutathione",
        "Boosts antioxidants",
        "Strengthens immune system",
        "Detoxifies the body",
      ],
    },
    ingredients: [
      "Sulforafano (semilla de brócoli)",
      "Selenio",
      "50+ polifenoles y fitonutrientes",
      "Vitaminas C, E, K, B6, B12",
      "Riboflavina, Niacina, Folato",
    ],
    usage:
      "1 sobre al día en agua o jugo. Se puede agregar a Immunocal, Platinum o Sport antes de mezclar.",
    targets: ["Baja actividad antioxidante", "Inmunidad débil", "Toxinas", "Estrés oxidativo"],
    presentation: "Caja con 30 sobres de 6 g",
  },
  {
    slug: "optimizer-performance",
    image: "/products/official/optimizer-performance.jpg",
    officialImage: "/products/official/optimizer-performance.jpg",
    sachetImage: "/products/lifestyle/optimizer-performance.png",
    name: { es: "Optimizer Performance", en: "Optimizer Performance" },
    tagline: {
      es: "Energía limpia y enfoque sostenido hasta 6 horas.",
      en: "Clean energy and sustained focus up to 6 hours.",
    },
    description: {
      es: "Immunocal Optimizer Performance® combina 3 fuentes orgánicas de cafeína con Nrf2 Catalyst™ para energía rápida y sostenida.",
      en: "Immunocal Optimizer Performance® blends 3 organic caffeine sources with Nrf2 Catalyst™ for fast, sustained energy.",
    },
    benefits: {
      es: [
        "Energía rápida y sostenida",
        "Mejora concentración",
        "Estimula tu estado de alerta",
        "Disminuye la fatiga",
        "Recarga Glutatión",
      ],
      en: [
        "Fast & sustained energy",
        "Improves focus",
        "Boosts alertness",
        "Reduces fatigue",
        "Recharges Glutathione",
      ],
    },
    ingredients: [
      "Extracto de té verde",
      "Extracto de café verde",
      "Extracto de semilla de guaraná",
      "Nrf2 Catalyst™",
      "Vitamina C, B12, Selenio",
    ],
    usage:
      "1 sobre al día. Combínalo con Immunocal o Platinum o Sport, o tómalo solo en 250 ml de agua.",
    targets: ["Baja energía", "Falta de concentración", "Fatiga", "Bajo estado de alerta"],
    presentation: "Caja con 30 sobres de 5.2 g",
  },
  {
    slug: "xtriva",
    image: "/products/official/xtriva.jpg",
    officialImage: "/products/official/xtriva.jpg",
    sachetImage: "/products/lifestyle/xtriva.png",
    name: { es: "XTRIVA Smart Gummy", en: "XTRIVA Smart Gummy" },
    tagline: {
      es: "Gomita inteligente con 8 nootrópicos para tu mente.",
      en: "Smart gummy with 8 nootropics for your mind.",
    },
    description: {
      es: "Xtriva™ con Syna-PS50 es una goma inteligente con 8 ingredientes nootrópicos para proteger, mantener y mejorar tu bienestar cognitivo.",
      en: "Xtriva™ with Syna-PS50 is a smart gummy with 8 nootropic ingredients to protect, maintain and improve cognitive wellness.",
    },
    benefits: {
      es: [
        "Potencializa la agudeza mental",
        "Aumenta atención y concentración",
        "Mejora memoria y creatividad",
        "Mejora rendimiento cognitivo",
        "Favorece salud mental a largo plazo",
      ],
      en: [
        "Sharpens mental edge",
        "Boosts attention & focus",
        "Improves memory & creativity",
        "Enhances cognitive performance",
        "Supports long-term mental health",
      ],
    },
    ingredients: [
      "Syna-PS50",
      "Bitartrato de colina",
      "Té verde",
      "Fosfatidilserina",
      "Boro",
      "Folato",
      "Picolinato de cromo",
      "Vitamina B12",
    ],
    usage: "1 tableta masticable al día.",
    targets: ["Deterioro cognitivo", "Falta de memoria", "Estrés", "Envejecimiento mental"],
    presentation: "Sobre con 30 tabletas masticables de 5 g",
  },
  {
    slug: "shake-it-up-vainilla",
    image: "/products/official/shake-vainilla.jpg",
    officialImage: "/products/official/shake-vainilla.jpg",
    sachetImage: "/products/lifestyle/shake-it-up-vainilla.png",
    name: { es: "Shake It Up! Vainilla", en: "Shake It Up! Vanilla" },
    tagline: {
      es: "Proteína premium con cúrcuma y fibra prebiótica, sabor vainilla.",
      en: "Premium protein with turmeric and prebiotic fiber, vanilla flavor.",
    },
    description: {
      es: "Shake It Up!® es una bebida proteica funcional con 20 g de proteína, 150 mg de cúrcuma y 4 g de fibra prebiótica por porción. Sin azúcares añadidos, keto friendly y certificación Clean Label.",
      en: "Shake It Up!® is a functional protein shake with 20g protein, 150mg turmeric and 4g prebiotic fiber per serving. No added sugar, keto-friendly, Clean Label certified.",
    },
    benefits: {
      es: [
        "20 g de proteína por porción",
        "Apoya el control de peso (Keto friendly)",
        "Cúrcuma antiinflamatoria 150 mg",
        "Fibra prebiótica para salud intestinal",
        "Solo 90 calorías por porción",
      ],
      en: [
        "20g protein per serving",
        "Supports weight management (keto-friendly)",
        "Anti-inflammatory turmeric 150mg",
        "Prebiotic fiber for gut health",
        "Only 90 calories per serving",
      ],
    },
    ingredients: ["Proteína de suero de leche", "Cúrcuma", "Fibra prebiótica", "Vitaminas y minerales"],
    usage: "1 porción al día, mezclada con 200-250 ml de agua o leche vegetal. Ideal como desayuno o post-entreno.",
    targets: ["Control de peso", "Inflamación", "Salud intestinal", "Falta de proteína en la dieta"],
    presentation: "Caja con 12 porciones · 360 g · Certificación Informed Sport",
  },
  {
    slug: "shake-it-up-chocolate",
    image: "/products/official/shake-chocolate.jpg",
    officialImage: "/products/official/shake-chocolate.jpg",
    sachetImage: "/products/lifestyle/shake-it-up-chocolate.png",
    name: { es: "Shake It Up! Chocolate", en: "Shake It Up! Chocolate" },
    tagline: {
      es: "Proteína premium con cúrcuma y fibra prebiótica, sabor chocolate.",
      en: "Premium protein with turmeric and prebiotic fiber, chocolate flavor.",
    },
    description: {
      es: "Shake It Up!® sabor chocolate — 20 g de proteína, 150 mg de cúrcuma y 4 g de fibra prebiótica por porción. Sin azúcares añadidos, keto friendly y certificación Clean Label.",
      en: "Shake It Up!® chocolate — 20g protein, 150mg turmeric and 4g prebiotic fiber per serving. No added sugar, keto-friendly, Clean Label certified.",
    },
    benefits: {
      es: [
        "20 g de proteína por porción",
        "Apoya control de peso (Keto friendly)",
        "Cúrcuma antiinflamatoria 150 mg",
        "Fibra prebiótica para microbiota",
        "Solo 90 calorías por porción",
      ],
      en: [
        "20g protein per serving",
        "Supports weight management",
        "Anti-inflammatory turmeric",
        "Prebiotic fiber for microbiota",
        "Only 90 calories per serving",
      ],
    },
    ingredients: ["Proteína de suero", "Cacao", "Cúrcuma", "Fibra prebiótica", "Vitaminas y minerales"],
    usage: "1 porción al día con 200-250 ml de agua o leche vegetal. Como desayuno o post-entreno.",
    targets: ["Control de peso", "Inflamación", "Microbiota intestinal", "Energía sostenida"],
    presentation: "Caja con 12 porciones · 360 g",
  },
  {
    slug: "shake-it-up-fresa",
    image: "/products/official/shake-fresa.jpg",
    officialImage: "/products/official/shake-fresa.jpg",
    sachetImage: "/products/lifestyle/shake-it-up-fresa.png",
    name: { es: "Shake It Up! Fresa", en: "Shake It Up! Strawberry" },
    tagline: {
      es: "Proteína premium con cúrcuma y fibra prebiótica, sabor fresa.",
      en: "Premium protein with turmeric and prebiotic fiber, strawberry flavor.",
    },
    description: {
      es: "Shake It Up!® sabor fresa — 20 g de proteína, 150 mg de cúrcuma y 4 g de fibra prebiótica. Sin azúcar añadido, keto friendly.",
      en: "Shake It Up!® strawberry — 20g protein, 150mg turmeric, 4g prebiotic fiber. No added sugar, keto-friendly.",
    },
    benefits: {
      es: [
        "20 g de proteína por porción",
        "Keto friendly · Sin azúcar añadido",
        "Cúrcuma antiinflamatoria 150 mg",
        "Fibra prebiótica 4 g",
        "Solo 90 calorías",
      ],
      en: [
        "20g protein per serving",
        "Keto-friendly · No added sugar",
        "Anti-inflammatory turmeric",
        "Prebiotic fiber 4g",
        "Only 90 calories",
      ],
    },
    ingredients: ["Proteína de suero", "Cúrcuma", "Fibra prebiótica", "Sabor natural de fresa"],
    usage: "1 porción al día con 200-250 ml de agua o leche vegetal.",
    targets: ["Control de peso", "Inflamación", "Salud intestinal"],
    presentation: "Caja con 12 porciones · 360 g",
  },
  {
    slug: "optimizer-jamaica",
    image: "/products/official/optimizer-jamaica.jpg",
    officialImage: "/products/official/optimizer-jamaica.jpg",
    sachetImage: "/products/lifestyle/optimizer-jamaica.png",
    name: {
      es: "Immunocal Optimizer Performance — Jamaica",
      en: "Immunocal Optimizer Performance — Hibiscus",
    },
    tagline: {
      es: "Energía limpia con sabor flor de Jamaica + activación Nrf2.",
      en: "Clean energy with hibiscus flavor + Nrf2 activation.",
    },
    description: {
      es: "Immunocal Optimizer® Performance sabor Flor de Jamaica — bebida funcional con mediador del Nrf2 y 3 fuentes naturales de cafeína para energía sostenida.",
      en: "Immunocal Optimizer® Performance hibiscus — functional drink with Nrf2 mediator and 3 natural caffeine sources for sustained energy.",
    },
    benefits: {
      es: [
        "Energía rápida y sostenida (hasta 6 hrs)",
        "Activa genes Nrf2 (mediador del Nrf2)",
        "Mejora concentración y estado de alerta",
        "Recarga el Glutatión",
        "Delicioso sabor Flor de Jamaica",
      ],
      en: [
        "Fast & sustained energy (up to 6 hrs)",
        "Activates Nrf2 genes",
        "Improves focus and alertness",
        "Recharges Glutathione",
        "Delicious hibiscus flavor",
      ],
    },
    ingredients: ["Té verde", "Café verde", "Guaraná", "Flor de Jamaica", "Nrf2 Catalyst™", "Vitamina C, B12, Selenio"],
    usage: "1 sobre al día disuelto en 250 ml de agua fría. Mejor antes del entrenamiento o por la mañana.",
    targets: ["Baja energía", "Fatiga", "Falta de concentración", "Estrés oxidativo"],
    presentation: "Caja con 30 sobres · 4 g cada uno · 120 g",
  },
  {
    slug: "bionutric",
    image: "/products/official/bionutric.jpg",
    officialImage: "/products/official/bionutric.jpg",
    sachetImage: "/products/lifestyle/bionutric.png",
    name: { es: "Bionutric", en: "Bionutric" },
    tagline: {
      es: "Glucosamina + Condroitina + MSM para articulaciones saludables.",
      en: "Glucosamine + Chondroitin + MSM for healthy joints.",
    },
    description: {
      es: "Bionutric® combina tres ingredientes clave —Glucosamina, Condroitina y MSM— para apoyar la salud de articulaciones, cartílago y movilidad.",
      en: "Bionutric® combines three key ingredients —Glucosamine, Chondroitin and MSM— to support joint health, cartilage and mobility.",
    },
    benefits: {
      es: [
        "Apoyo a articulaciones y cartílago",
        "Mejora la movilidad",
        "Reduce molestias articulares",
        "Soporte para tejidos conectivos",
        "Ideal para adultos activos y mayores",
      ],
      en: [
        "Joint and cartilage support",
        "Improves mobility",
        "Reduces joint discomfort",
        "Connective tissue support",
        "Ideal for active adults and seniors",
      ],
    },
    ingredients: ["Glucosamina", "Condroitina", "MSM (Metilsulfonilmetano)"],
    usage: "2 a 4 tabletas al día con los alimentos. Consulta a tu médico antes de iniciar.",
    targets: ["Dolor articular", "Movilidad reducida", "Desgaste de cartílago", "Lesiones deportivas"],
    presentation: "Frasco con 120 tabletas de 600 mg",
  },
  {
    slug: "wimms",
    image: "/products/official/wimms.jpg",
    officialImage: "/products/official/wimms.jpg",
    sachetImage: "/products/lifestyle/wimms.png",
    name: { es: "Wimms", en: "Wimms" },
    tagline: {
      es: "Gomitas con Omega 3 y vitaminas para los más pequeños.",
      en: "Gummies with Omega 3 and vitamins for kids.",
    },
    description: {
      es: "Wimms® es un suplemento en gomitas a base de Omega 3 (EPA y DHA) con más de 5 vitaminas, formulado para apoyar el crecimiento, desarrollo cognitivo y sistema inmune de los niños. Tecnología de rápida absorción.",
      en: "Wimms® is a gummy supplement based on Omega 3 (EPA & DHA) with 5+ vitamins, formulated to support kids' growth, cognitive development and immune system. Fast-absorption technology.",
    },
    benefits: {
      es: [
        "Apoya el desarrollo cognitivo",
        "Refuerza el sistema inmune infantil",
        "Salud visual y cerebral",
        "Sin azúcares, gluten, lactosa ni OGM",
        "Sabor natural delicioso",
      ],
      en: [
        "Supports cognitive development",
        "Boosts kids' immune system",
        "Eye and brain health",
        "Sugar / gluten / lactose / GMO free",
        "Delicious natural flavor",
      ],
    },
    ingredients: ["Omega 3 (EPA y DHA)", "5+ vitaminas", "Tecnología de rápida absorción"],
    usage: "1 a 2 gomitas al día para niños mayores de 4 años. Consulta a tu pediatra.",
    targets: ["Bajo rendimiento escolar", "Inmunidad infantil débil", "Desarrollo cognitivo", "Niños quisquillosos con la comida"],
    presentation: "Caja con 30 gomitas de 1.6 g · Sin azúcares · Sin gluten · Sin lactosa · Libre de OGM",
  },
];
